/**
 * Cómo se presenta el estado de un envío de Registro Académico. Lo comparten la
 * campana de la barra superior y el detalle del envío en la pantalla de
 * Integración, para que los dos digan lo mismo con el mismo color.
 */
export function colorEstado(estado) {
   if (estado === 'MODIFICADO') return 'orange darken-2'
   if (estado === 'IMPORTADO') return 'green darken-2'
   if (estado === 'DESCARTADO') return 'blue-grey'
   return 'red darken-2'
}

export function etiquetaEstado(estado) {
   if (estado === 'MODIFICADO') return 'Modificado'
   if (estado === 'IMPORTADO') return 'Procesado'
   if (estado === 'DESCARTADO') return 'Descartado'
   return 'Sin procesar'
}

/** Meses que piden atención: sin procesar o cambiados después de procesarlos. */
export function esPendiente(envio) {
   return envio.estado === 'PENDIENTE' || envio.estado === 'MODIFICADO'
}

/** Evento global con el que la pantalla avisa a la campana que algo cambió. */
export const EVENTO_ENVIOS_ACTUALIZADOS = 'integracion:envios-actualizados'
